import { IUser } from '@reverbdotcom/commons/src/components/user_context_provider';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import experiments from './experiments';

function isNonUSUser(user: Partial<IUser>) {
  return !!user?.countryCode && user.countryCode !== 'US';
}

export function trackLocalizeCSPCardExperiment(user: Partial<IUser>) {
  if (isNonUSUser(user)) {
    return [experiments.LOCALIZE_CSP_CARD];
  }

  return [];
}

export function isUserInLocalizeCSPCardExperiment(user: Partial<IUser>) {
  return isExperimentEnabled(user, experiments.LOCALIZE_CSP_CARD);
}
